<template><section><h3>图表介绍</h3>
<p>Bar Chart, 柱状图、条形图。</p>
<h3>attrs</h3>
<p>attrs 包含若干布局属性，将这些属性放入 Object 对象传入组件</p>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>barWidth</td>
<td>Number</td>
<td>根据 size 宽度均匀绘制</td>
<td>描述柱形宽度</td>
</tr>
<tr>
<td>mouseDisabled</td>
<td>Boolean</td>
<td>false</td>
<td>组件鼠标是否禁用</td>
</tr>
<tr>
<td>clientRect</td>
<td>Object</td>
<td>{top,right,bottom,left,width,height}</td>
<td>设置了 width,heigh,优先与 bottom,right</td>
</tr>
<tr>
<td>splitNumber</td>
<td>Number</td>
<td>0</td>
<td>坐标轴的分割段数，用来计算柱子的最大高度，在设置坐标轴的 splitNumber 属性时同步加上</td>
</tr>
<tr>
<td>stack</td>
<td>Boolean</td>
<td>false</td>
<td>是否设置为堆叠图，二维数据无法堆叠</td>
</tr>
<tr>
<td>stackGap</td>
<td>Number</td>
<td>0</td>
<td>堆叠图中柱子间距</td>
</tr>
<tr>
<td>transpose</td>
<td>Boolean</td>
<td>false</td>
<td>是否设置为条形图</td>
</tr>
</tbody>
</table>
<h3>style 属性</h3>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基本类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>backgroundpillar</td>
<td>面</td>
<td>背景柱子样式</td>
</tr>
<tr>
<td>pillar</td>
<td>面</td>
<td>柱子样式</td>
</tr>
<tr>
<td>pillar:hover</td>
<td>面</td>
<td>鼠标 hover 时柱子样式</td>
</tr>
<tr>
<td>text</td>
<td>文本</td>
<td>文本样式</td>
</tr>
</tbody>
</table>
<p>使用方法可在<a href="#/demo/column/others">样式调整 demo</a>中查看，用法如下：</p>
<p>style 设置方式可以是 Boolean、 obj 属性或者函数，例如：</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-comment">// 新建Bar组件</span>
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar()

<span class="hljs-comment">//设置true或false来隐藏组件元素</span>
<span class="hljs-comment">//隐藏背景柱</span>
bar.style(<span class="hljs-string">"backgroundpillar"</span>, <span class="hljs-literal">false</span>)

<span class="hljs-comment">//设置spritejs的attr属性来设置样式</span>
<span class="hljs-comment">//设置鼠标移入柱子时样式</span>
bar.style(<span class="hljs-string">"pillar:hover"</span>, { <span class="hljs-attr">bgcolor</span>: <span class="hljs-string">"#f00"</span>, <span class="hljs-attr">opacity</span>: <span class="hljs-string">"0.5"</span> })

<span class="hljs-comment">//attrs为元素绘制属性，data为元素对应数据，i为元素序列</span>
bar.style(<span class="hljs-string">"pillar:hover"</span>, (attrs, data, i) =&gt; {
  <span class="hljs-comment">//将偶数序列的柱子设置圆角</span>
  <span class="hljs-keyword">if</span> (i % <span class="hljs-number">2</span> === <span class="hljs-number">0</span>) {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">borderRadius</span>: <span class="hljs-number">10</span>,
    }
  }
  <span class="hljs-keyword">return</span> { <span class="hljs-attr">opacity</span>: <span class="hljs-number">0.5</span>, <span class="hljs-attr">bgcolor</span>: <span class="hljs-string">"blue"</span> }
})
</code></pre>
</section></template><script>export default {components:{}}</script>